import { GetOrderInfoQuery, GetOrderInfoQueryVariables } from './__generated__/sdk';
import { getOrdersClient } from './client';

export async function getOrderInfo(variables: GetOrderInfoQueryVariables): Promise<GetOrderInfoQuery> {
  const client = await getOrdersClient();
  return client.GetOrderInfo(variables);
}
